import { useToast } from "@chakra-ui/react";
import request from '@/http/request';
import storage from '@/utils/jeepayStorageWrapper.js'

let timer = null;

const useFetchData = (...args) => {
    const toast = useToast();
    return request.request({
      ...args[0]
    }).then(res => {
      return res
    }).catch((err) => {
      if (err.code !== 0) {
        toast({
          title: err.msg,
          status: "error",
        })
      }
      if (err.status) {
        if (err.status === 401) {
          toast({
            title: '登录过期，请重新登录',
            status: "error",
          })
          storage.cleanToken()
          clearTimeout(timer)
  
          timer = setTimeout(() => {
            window.location.href = '/auth/sign-in'
          }, 1000)
        } else {
          toast({
            title: err.msg,
            status: "error",
          })
        }
      }
      return err
    })
};

export default useFetchData;